export default __webpack_public_path__ + "static/media/google-analytics-logo.1cc0abb2.svg";